import React from 'react';
import { Typography, TypographyOwnProps } from '@mui/material';
import { FormattedTextField, TextField } from 'framework/ui/field';
import InfoRow from './InfoRow';
import InfoCard from './InfoCard';

const getCPIColor = (value: number): TypographyOwnProps['color'] => {
  if (value < 0.97) return 'error';
  if (value > 1.03) return 'success';
  return 'warning';
};

const ProjectBudget: React.FC = () => {
  return (
    <InfoCard title="Project budget">
      <InfoRow label="Projected budget, hours">
        <TextField label="" source="projectBudget.projectedBudgetHours" />
      </InfoRow>

      <InfoRow label="Budget total/used, hours">
        <FormattedTextField
          label=""
          source="projectBudget"
          format={(str: any) =>
            !str ? '—' : `${str?.budgetTotalHours} / ${str?.budgetUsedHours} (${str?.budgetUsedPercentage}%)`
          }
        />
      </InfoRow>

      <InfoRow label="Budget remaining, hours">
        <TextField label="" source="projectBudget.budgetRemainingHours" />
      </InfoRow>

      <InfoRow label="CPI, budget">
        <FormattedTextField
          label=""
          source="projectBudget.cpiBudget"
          format={(str: string) => <Typography color={getCPIColor(Number(str))}>{str || '—'}</Typography>}
        />
      </InfoRow>

      <InfoRow label="CPI budget projection, hours" isLast>
        <TextField label="" source="projectBudget.cpiBudgetProjectionHours" />
      </InfoRow>
    </InfoCard>
  );
};

export default ProjectBudget;
